import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "../styles/banners.css";
import Constant from "../helper/Constant";

const OfferBannerSlider = () => {
  const [current, setCurrent] = useState(0);
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    const getBanners = async () => {
      try {
        const response = await axios.get(
          `${Constant.getUrls.getBanners}?page=1&limit=10&status=active`
        );

        setBanners(response?.data?.data?.docs || []);
      } catch (error) {
        console.error("Failed to load banners:", error);
      }
    };

    getBanners();
  }, []);

  useEffect(() => {
    if (banners.length <= 1) return undefined;

    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % banners.length);
    }, 3500);

    return () => clearInterval(timer);
  }, [banners]);

  if (!banners.length) return null;

  return (
    <section className="banner-section">
      <div className="custom-slider">
        {banners.map((item, index) => {
          const imageSrc = `${Constant.imageDomain}${item.image}`;
          const categoryPath = item?.category_id?._id
            ? `/products?catId=${item.category_id._id}`
            : "";
          const bannerLink = item.link || categoryPath;

          return (
            <div
              key={item._id}
              className={`slide ${index === current ? "active" : ""}`}
            >
              {bannerLink ? (
                bannerLink.startsWith("http") ? (
                  <a href={bannerLink} target="_blank" rel="noreferrer">
                    <img src={imageSrc} alt={item.title || "Banner"} />
                  </a>
                ) : (
                  <Link to={bannerLink}>
                    <img src={imageSrc} alt={item.title || "Banner"} />
                  </Link>
                )
              ) : (
                <img src={imageSrc} alt={item.title || "Banner"} />
              )}
            </div>
          );
        })}
      </div>

      <div className="slider-dots">
        {banners.map((item, index) => (
          <span
            key={item._id}
            className={index === current ? "dot active" : "dot"}
            onClick={() => setCurrent(index)}
          />
        ))}
      </div>
    </section>
  );
};

export default OfferBannerSlider;
